<span>
  Alle mit
  <app-required-asterisk />
  gekennzeichneten Felder sind Pflichtfelder
</span>
